export const headerHeight = () => {
    const h = document.getElementById("header");
    if (h) {
        document.documentElement.style.setProperty(
            "--headerHeight",
            h.offsetHeight + "px"
        );
    }
};
